/*********************** Custom JS for Boost AI Search & Discovery  ************************/

/* Starts Boost-209650 */
const customize = {
  displayProductType: (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductItem", {
      name: "Do something",
      enabled: true,
      apply: () => ({
        props: (props) => {
          return props;
        },
        afterRender(element) {
          const productData = element.getParams().props.product;
          // console.log(productData);
          let productId;
          if ("split_product" in productData) {
            productId = productData.variant_id;
          } else {
            productId = productData.id;
          }
          let productItem = document.querySelector(
            '[data-product-id="' + productId + '"]'
          );
          productItem.querySelector("pickup-availability-compact");
          if (!productItem.querySelector("pickup-availability-compact")) {
            // productItem.insertAdjacentHTML(
            //   "beforeend",
            //   `
            //   <div class="collection-online-availibility-container" id="online-availibility-container-${productData.variants[0].id}" data-product-id="${productData.id}"
            //   data-variant-id="${productData.variants[0].id}"></div>
            //   <div class="store-pickup-available" id="store-pickup-available-${productData.id}" data-product-id="${productData.id}"></div>
            //   `
            // );
            // <pickup-availability-compact class="collections-page-pickup"
            //   data-product-id="${productData.id}"
            //   data-variant-id="${productData.variants[0].id}"
            // >
            //   <span class="alert alert--note alert--circle alert--circle-loading">
            //     Checking local availibility...
            //   </span>
            // </pickup-availability-compact>
        //   console.log(productData.variants[0].id);
            //isListProductAvaiableOnline(productData.variants[0].id,productData.id);
          // isListProductAvaiableOnStore(productData.id);
          //  isListProductAvaiableOnlineAndStore(productData.id, productData.variants[0].id);
          }

          try {
            const productData = element.getParams().props.product;
            let productId;
            if ("split_product" in productData) {
              productId = productData.variant_id;
            } else {
              productId = productData.id;
            }
            let productItem = document.querySelector(
              '[data-product-id="' + productId + '"]'
            );

            let productType = document.createElement("div");
            productType.innerHTML = productData.product_type;
            productType.classList.add("boost-sd__product-type");
            productType.style.textTransform = "uppercase";
            if (
              productItem.querySelector(
                ".boost-sd__integration-product-rating"
              ) &&
              !productItem.querySelector(".boost-sd__product-type")
            ) {
              const productRating = productItem.querySelector(
                ".boost-sd__integration-product-rating"
              );
              productRating.parentNode.insertBefore(productType, productRating);
            }
            /* Boost 214789 */
            let discountMsg = productData.metafields.find(
              (item) => item.key === "discount_code_message"
            );
            let discountMsgHtml = productData.metafields.find(
              (item) => item.key === "discount_code_html"
            );
            let savingMsg = productData.metafields.find(
              (item) => item.key === "savings_message"
            );
            let discountColor = productData.metafields.find(
              (item) => item.key === "discount_code_bgcolor"
            );
            let discountDiv = document.createElement("div");
            let savingDiv = document.createElement("div");
            discountDiv.classList.add("discount-message");
            savingDiv.classList.add("saving-message");
            // let productInfo = productItem.querySelector(".boost-sd__product-info");
            let productBtn = productItem.querySelector(".boost-sd__button");

if (
  discountMsgHtml && discountMsgHtml.value &&
  !productItem.querySelector(".discount-message")
) {
              const msgHtml = JSON.parse(discountMsgHtml.value)["children"][0][
                "children"
              ];
              let textHtml = "";
              if (msgHtml) {
                msgHtml.forEach(function (text, index) {
                  if (text.bold) {
                    textHtml +=
                      '<b class="highlighted-code">' + text.value + "</b>";
                  } else {
                    textHtml += text.value;
                  }
                });
              }

              discountDiv.innerHTML = textHtml;
if (discountColor && discountColor.value) {
  discountDiv.style.backgroundColor = discountColor.value;
}
              // productInfo.appendChild(discountDiv);
              productBtn.parentNode.insertBefore(discountDiv, productBtn);
            }
if (
  savingMsg && savingMsg.value &&
  !productItem.querySelector(".saving-message")
) {
              savingDiv.innerHTML = savingMsg.value;
              // productInfo.appendChild(savingDiv);
              productBtn.parentNode.insertBefore(savingDiv, productBtn);
            }

            /* Boost 214789 */
          } catch (error) {
            console.log(error);
          }
        },
      }),
    });
  },
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.displayProductType,
]);

/* Ends Boost-209650 */

/* Starts Boost-213998  */
if (boostSDAppConfig?.themeSettings) {
  boostSDAppConfig.themeSettings.cart.cartStyle = "none";
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useModulePlugin("CartAPI", {
      name: "Integrate theme cart drawer",
      apply(builder) {
        builder.on("methodFulfilled", "addToCart", async (payload) => {
          const cartDrawerElm = document.querySelector("#site-cart-sidebar");
          if (
            payload.result.ok &&
            cartDrawerElm &&
            typeof refreshCart !== "undefined"
          ) {
            refreshCart();
            cartDrawerElm.show();
            return payload;
          }
        });
      },
    });
  },
]);

/* End Boost-213998  */

async function  isListProductAvaiableOnline(productVariantId,product_id){
 // console.log('in function');
      if (!productVariantId) {
        return;
      }
      const response = await fetch(
        zapietGadgetAppBaseUrl + "isAvailable",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            productVariantId: productVariantId,
            product_id: product_id,
            source:'collection',
            quantity: 1,
          }),
        }
      );
      const data = await response.json();
      // console.log(data);
              let resultContainer = document.querySelector("#online-availibility-container-"+productVariantId)
      if(data.available){
        resultContainer.innerHTML = `<span class="alert alert--circle alert--success d-flex"> <span></span> <span>In Stock Online</span> </span>`;
      }else{
       resultContainer.innerHTML = `<span class="alert alert--circle alert--error d-flex"> <span></span><span>Out of Stock Online</span> </span>`;
      }
    }
/* custom code to get product avaiable online*/
async function  isListProductAvaiableOnStore(product_id){
 // console.log('in function');
      if (!product_id) {
        return;
      }
  let selectedStore = localStorage.getItem("selected-store");
          if (selectedStore == null || selectedStore == "") {
            return;
          }
  
  //return false;
  let resultContainer = document.querySelector("#store-pickup-available-"+product_id)
let xhr = new XMLHttpRequest();
 
    // Making our connection  
      let url = window.en_api_url+'/isAvailableforStore.php?pid='+product_id+'&store='+selectedStore;
    xhr.open("GET", url, true);

    // function execute after request is successful 
    xhr.onreadystatechange = function () {
           //console.log(this.response);
      try {
      var data = JSON.parse(this.response);
      if(data.available){
        resultContainer.innerHTML = `<span class="alert alert--circle alert--success d-flex"> <span></span> <span>In Stock `+selectedStore+`</span> </span>`;
      }else{
       resultContainer.innerHTML = `<span class="alert alert--circle alert--error d-flex"> <span></span><span>Out of Stock for `+selectedStore+`</span> </span>`;
      }Ï
        return true;
    } catch (error) {
        return false;
    }
       
    }
    // Sending our request 
    xhr.send();
  return false;
  

    }

async function  isListProductAvaiableOnlineAndStore(product_id, variant_id){
 
      if (!product_id) {
        return;
      }
  let selectedStore = localStorage.getItem("selected-store");
         
  
  //return false;
  let store_resultContainer = document.querySelector("#store-pickup-available-"+product_id) 
  
  //return false;
  let online_resultContainer = document.querySelector("#online-availibility-container-"+variant_id)
let xhr = new XMLHttpRequest();
 
    // Making our connection  
      let url = window.en_api_url+'/isAvailableforOnlineAndStore.php?pid='+product_id+'&store='+selectedStore;;
    xhr.open("GET", url, true);

    // function execute after request is successful 
    xhr.onreadystatechange = function () {
           //console.log(this.response);
      try {
      var data = JSON.parse(this.response);
      if(data.is_online_available){
        online_resultContainer.innerHTML = `<span class="alert alert--circle alert--success d-flex"> <span></span> <span>In Stock Online</span> </span>`;
      }else{
         online_resultContainer.innerHTML = `<span class="alert alert--circle alert--error d-flex"> <span></span><span>Out of Stock Online</span> </span>`;
      }

 if (selectedStore == null || selectedStore == "") {
            return;
          }
        if(data.available){
        store_resultContainer.innerHTML = `<span class="alert alert--circle alert--success d-flex"> <span></span> <span>In Stock `+selectedStore+`</span> </span>`;
      }else{
       store_resultContainer.innerHTML = `<span class="alert alert--circle alert--error d-flex"> <span></span><span>Out of Stock for `+selectedStore+`</span> </span>`;
      }
        
        return true;
    } catch (error) {
        return false;
    }
       
    }
    // Sending our request 
    xhr.send();
  return false;
  

    }